<template>
   <section class="bg-gray-50 py-16 md:py-24" id="partners">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            招聘信息
          </h2>
          <div class="w-20 h-1 bg-blue-700 mx-auto mb-6"></div>
          <p class="text-gray-700 max-w-3xl mx-auto">
            暂无招聘信息
          </p>
        </div>
     </div>
       
    </section>
</template>

<script>
export default {
  name: "HirePage",
};
</script>
